import React from 'react';
import { Dialog } from '@mui/material';
import { DialogContent } from '~/components/organisms/DialogContent/index.ts';
import { Typography } from '~/index.ts';
import { defaultCustomerFormTexts } from './formTexts.ts';

export interface ResetCreditAppDialogProps {
  onContinue: () => void;
  onCancel: () => void;
}

const ResetCreditAppConfirmation: React.FC<ResetCreditAppDialogProps> = ({
  onContinue,
  onCancel,
}) => {
  const bodyContent = (
    <Typography variant="h6">
      {defaultCustomerFormTexts.resetCreditAppConfirmation.description}
    </Typography>
  );

  const secondaryButton = {
    children: defaultCustomerFormTexts.resetCreditAppConfirmation.cancel,
    onClick: onCancel,
  };

  const primaryButton = {
    children: defaultCustomerFormTexts.resetCreditAppConfirmation.continue,
    onClick: onContinue,
  };

  return (
    <Dialog open onClose={onCancel}>
      <DialogContent
        title={''}
        bodyContent={bodyContent}
        secondaryButton={secondaryButton}
        primaryButton={primaryButton}
        onCancel={onCancel}
        size="medium"
      />
    </Dialog>
  );
};

export default ResetCreditAppConfirmation;
